module.exports = new __parcel__URL__("general-settings-app-skeleton.tpl.b9bd2bdd.svg").toString();